import CityPageTemplate from "../city-template/CityPageTemplate";
import { kennewickConfig } from "./data";

export default function KennewickPage() {
  return <CityPageTemplate config={kennewickConfig} />;
}